<template>
  <div id="app">
    <router-view />
    <Toast />
  </div>
</template>

<script>
import Toast from 'primevue/toast'

export default {
  name: 'App',
  components: {
    Toast
  }
}
</script>

<style>
#app {
  min-height: 100vh;
}
</style>